import { useInfiniteQuery } from "react-query";
import queryKeys from "reactQuery/queryKeys";

import useOwnCompany from "hooks/queries/useOwnCompany";
import { getOwnGroups } from "shared/client";

const DEFAULT_PAGESIZE = 5;

export default function useOwnGroups(
  { limit }: { limit: number } = {
    limit: DEFAULT_PAGESIZE,
  }
) {
  const { data: ownCompany } = useOwnCompany();

  return useInfiniteQuery(
    queryKeys.ownGroups(ownCompany!.id),
    ({ pageParam: offset }) => {
      return getOwnGroups({ offset, limit });
    },
    {
      enabled: !!ownCompany?.id,
      getNextPageParam(lastPage, allPages) {
        if (lastPage.length !== limit) {
          return null;
        }

        const fetchedCount = allPages.reduce(
          (sum, page) => sum + page.length,
          0
        );

        return fetchedCount;
      },
    }
  );
}
